import { useEffect, useState } from 'react';
import type { RefObject } from 'react';

export type ScrollEdges = { start: boolean; end: boolean };

// Which ends of a horizontal scroller still hide content — drives the My bookings tab
// row's edge fades (design changelog M3: at 390 "Cancelled" was cut with no hint).
// Re-measured on scroll and resize; `key` re-measures when the content changes.
export function useScrollEdges(ref: RefObject<HTMLElement | null>, key?: unknown): ScrollEdges {
  const [edges, setEdges] = useState<ScrollEdges>({ start: false, end: false });
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const measure = () => {
      const max = el.scrollWidth - el.clientWidth;
      const next = { start: el.scrollLeft > 1, end: max - el.scrollLeft > 1 };
      setEdges((cur) => (cur.start === next.start && cur.end === next.end ? cur : next));
    };
    measure();
    el.addEventListener('scroll', measure, { passive: true });
    const ro = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(measure);
    ro?.observe(el);
    return () => {
      el.removeEventListener('scroll', measure);
      ro?.disconnect();
    };
  }, [ref, key]);
  return edges;
}
